<template>

<div>
    <settingsNav></settingsNav>

    <v-container>

        <v-layout row wrap>

            <v-flex xs12 sm12 mb-2>

                <v-btn class="secondary white--text" @click.stop="openDialog(null)">
                    New Terms Of Payment
                    <v-icon class="white--text" right>add</v-icon>
                </v-btn>

            </v-flex>

        </v-layout>

        <v-layout row wrap>

            <v-flex xs12 sm12>
                <v-layout row>
                    <v-flex xs12>

                        <v-card>
                            <v-card-title>
                                <v-card-title class="headline">
                                    Terms Of Payment
                                </v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                        clearable
                                ></v-text-field>
                            </v-card-title>

                            <v-data-table
                                    :headers="headers"
                                    :items="getItems"
                                    :pagination.sync="pagination"
                                    :total-items=total
                                    class="elevation-0"
                                    :loading="loading"
                                    :rows-per-page-items="rowsPageItems"
                            >

                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                  <v-touch tag="tr"
                                           @doubletap="openDialog(props.item.id)"
                                           @dblclick="openDialog(props.item.id)">
                                        <td>{{ props.item.id }}</td>
                                        <td class="text-xs-left">{{ props.item.name }}</td>
                                        <td class="text-xs-left">{{ props.item.description }}</td>
                                  </v-touch>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                </v-layout>

                <addTermsOfPaymentDialog></addTermsOfPaymentDialog>

            </v-flex>
        </v-layout>

    </v-container>
</div>

</template>

<script>
    // Types
    import {
        Settings,
        TermsOfPaymentSettings
    } from '../../../store/namespace-helper'

    import addTermsOfPaymentDialog from '../TermsOfPayment/AddTermsOfPaymentDialog.vue'
    import settingsNav from '../../Shared/SettingsNav.vue'
    import {stateHelperMixin} from '../../../mixins/stateHelperMixin'
    import _ from 'lodash'

    export default {
      name: 'terms-of-payment',
      components: {
        addTermsOfPaymentDialog,
        settingsNav
      },
      mixins: [stateHelperMixin],
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'TermsOfPayment-ID', value: 'id'},
                    {text: 'Terms Of Payment Name', value: 'name'},
                    {text: 'Description', value: 'description'}
          ],
          pagination: {},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [10, 25, 50, 100, 250]
        }
      },
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadItems()
      },
      methods: {
        openDialog (val) {
          if (val !== null) {
            let item = this.getItems.find(x => x.id === val)
            this.$store.dispatch(TermsOfPaymentSettings.actions.setSelectedTermOfPayment, item)
          }
          this.$store.dispatch(TermsOfPaymentSettings.actions.openCloseNewDialog)
        },
        loadItems: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          this.$store.dispatch(TermsOfPaymentSettings.actions.loadTermsOfPayments, query)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450)
      },
      computed: {
        getItems () {
          console.log('TermsOfPaymentSettings.getters.termsOfPayments: ' + TermsOfPaymentSettings.getters.termsOfPayments)
          this.total = this.$store.getters[TermsOfPaymentSettings.getters.termsOfPayments].total
          return this.$store.getters[TermsOfPaymentSettings.getters.termsOfPayments].data
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Settings/TermsOfPayment/TermsOfPayment.vue